import forOwn from 'mout/object/forOwn'

// computes attributes of Composite circle
export default function getCompositeCircleData (
  subtests,
  scoring,
  scoringCompare,
  compositeScore,
  notInitializing,
  compositeScoreCompare,
  test1,
  test2,
  isSwap
) {
  let labels = ['English', 'Math', 'Reading', 'Science', '']
  let data = [1, 1, 1, 1, 0]
  let backgroundColor = ['#4d4d4d', '#4d4d4d', '#4d4d4d', '#4d4d4d', '#4d4d4d']
  let hoverBackgroundColor = backgroundColor

  if (subtests && scoring) {
    let scores = {
      English: 0,
      Math: 0,
      Reading: 0,
      Science: 0,
      nil: 144,
    }
    if (scoring) {
      forOwn(scoring.bySubtest, (val, key, o) => {
        if (val.complete) {
          const thisScale = val.scale
          const thisSubject = subtests[key].displayName
          scores[thisSubject] = thisScale
          scores.nil -= thisScale
        }
      })
    }
    if (scores.nil < 144) {
      data = [
        scores.English,
        scores.Math,
        scores.Reading,
        scores.Science,
        scores.nil,
      ]
      backgroundColor = ['purple', '#f86c6b', '#20a8d8', '#4dbd74', '#4d4d4d',]
      hoverBackgroundColor = backgroundColor
    }
  }

  //---------------
  if (subtests && scoringCompare) {
    let scoringCompare = {
      English: 0,
      Math: 0,
      Reading: 0,
      Science: 0,
      nil: 144,
    }
    
    if (scoringCompare) {
      forOwn(scoringCompare.bySubtest, (val, key, o) => {
        if (val.complete) {
          const thisScale = val.scale
          const thisSubject = subtests[key].displayName
          scoringCompare[thisSubject] = thisScale
          scoringCompare.nil -= thisScale
        }
      })
    }
    if (scoringCompare.nil < 144) {
      data = [
        scoringCompare.English,
        scoringCompare.Math,
        scoringCompare.Reading,
        scoringCompare.Science,
        scoringCompare.nil,
      ]
      backgroundColor = ['purple', '#f86c6b', '#20a8d8', '#4dbd74', '#4d4d4d',]
      hoverBackgroundColor = backgroundColor
    }
  }
  return {
    labels,
    data,
    backgroundColor,
    hoverBackgroundColor,
    score: compositeScore,
    compareScore: compositeScoreCompare,
    subject: 'Composite',
    top: true,
    notInitializing:notInitializing,
    test1,
    test2,
    isSwap
  }
}


// WEBPACK FOOTER //
// ./src/helpers/assessment/assessmentDashboard/getCompositeCircleData.js